import React, { useState, useEffect, useContext, useImperativeHandle, forwardRef } from 'react';

import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import SearchIcon from '@mui/icons-material/Search';
import { GridLogicOperator } from '@mui/x-data-grid-pro';
import InputAdornment from '@mui/material/InputAdornment';
import FilterCheckBox from 'components/object/filter/FilterCheckBox';
import TextFieldCustom from 'components/object/formElement/TextFieldCustom';
import DesktopDatePickerCustom from 'components/object/formElement/DesktopDatePickerCustom';
import moment from 'moment';

import { ContextFilter } from "context/ContextFilter";

import 'styles/boxicons.css';

const TrainingFilter = forwardRef((props, ref) => {

  //context
  const { 
    setRows,
    totalRows,
    filterName,
    setLoadingGrid,
    dataGridLoaded,
    setFilterModel,
    filterOn, setFilterOn,
    searchText, setSearchText,
    searchTextState, setSearchTextState,
    filterDatas, setFilterDatas,
    dateSessionStart, setDateSessionStart,
    intraInter, setIntraInter,
    status, setStatus
  } = useContext(ContextFilter);


  //useEffect
  useEffect(() => {
    var filter = JSON.parse(localStorage.getItem(filterName));

    if (filter) {
      //INIT DATAS Filter list
      setFilterDatas(filter.datas);

      //INIT SEARCH TXT CATEGORY
      if (filter.search) {
        setSearchText(filter.search);
      }
      resetFilterResetButton(filter.datas, filter.search);
    }
  }, []);


  //function
  useImperativeHandle(ref, () => ({
    initFilter(totalRowsParam) {
      initFilterMissions(totalRowsParam);
    },
  }));

  function initFilterMissions(totalRowsParam) {
    var filter = JSON.parse(localStorage.getItem(filterName));

    if (filter) {
      setDateSessionStart(moment(filter.datas.dateSessionStart));
      setIntraInter(filter.datas.intraInter);
      setStatus(filter.datas.status);

      selectDataContent(filter.datas, filter.search, totalRowsParam);
      setSearchTextAction(filter.search, filter.datas);
    }
  }

  function setFilterSelectedLocalStorage(filterDataParam, searchTxt) {
    var filter = { datas: filterDataParam, search: searchTxt };
    localStorage.setItem(filterName, JSON.stringify(filter));
  }

  function selectDataContent(filterDataParam, searchTxtParam, totalRowsParam) {
    var searchTxtVar = searchText;
    var totalRowsVar = totalRows;
    if (searchTxtParam || totalRowsParam) {
      searchTxtVar = searchTxtParam;
      totalRowsVar = totalRowsParam;
    }

    setLoadingGrid(true);
    var selectedRows = [];
    var addRow = true;
    for (var i = 0; i < totalRowsVar.length; i++) {
      addRow = true;
      if (filterDataParam.dateSessionStart !== null) {
        // setting hours to 0 to be sure we compare only dates
        const startDate = new Date(Date.parse(totalRowsVar[i].startDate)).setHours(0,0,0,0);
        const searchDate = new Date(Date.parse(filterDataParam.dateSessionStart)).setHours(0,0,0,0);
        if (startDate < searchDate) addRow = false;
      }
      if (filterDataParam.intraInter !== '' && totalRowsVar[i].inter !== filterDataParam.intraInter) addRow = false;
      if (filterDataParam.status !== '' && totalRowsVar[i].status.code != filterDataParam.status) addRow = false;

      if (addRow) selectedRows[selectedRows.length] = totalRowsVar[i];
    }

    setRows(selectedRows);
    setLoadingGrid(false);
    setFilterSelectedLocalStorage(filterDataParam, searchTxtVar);
    resetFilterResetButton(filterDataParam, searchTxtVar);
  }

  function setSearchTextAction(searchTxtAct, filterDatasParam) {
    var filterDatasVar = filterDatas;
    if (filterDatasParam) filterDatasVar = filterDatasParam;

    if (searchTxtAct.length > 0) {
      setFilterModel({
        items: [
          /*{ id: 1, field: "code", operator: 'contains', value: searchTxtAct, },
          { id: 2, field: "placeInfo", operator: 'contains', value: searchTxtAct, },
          { id: 3, field: "manager", operator: 'contains', value: searchTxtAct, },
          { id: 4, field: "subsessions", operator: 'contains', value: searchTxtAct, }*/
          { id: 1, field: 'filtering', operator: 'contains', value: searchTxtAct, }
        ],
        logicOperator: GridLogicOperator.Or,
      });
    } else {
      setFilterModel({ items: [] });
    }
    setFilterSelectedLocalStorage(filterDatasVar, searchTxtAct);
    resetFilterResetButton(filterDatasVar, searchTxtAct);
  }

  const handleChangeSearchText = (event) => {
    setSearchText(event.target.value);
    if (event.target.value.length > 0) {
      setSearchTextState('');
      setSearchTextAction(event.target.value);
    }
    else {
      if (event.target.value.length === 0) {
        setSearchTextState('');
        setSearchTextAction(event.target.value);
      }
      else {
        setSearchTextState('warning');
      }
    }
  }

  //SETTER
  function createHandler(data) {
    return { id: data.id, value: data.id, alias: data.label };
  }

  //Filter
  function setDateSessionStartHandler(data) {
    setDateSessionStart(data);
    var filterData = { dateSessionStart: data, intraInter: intraInter, status: status };
    setFilterDatas(filterData);
    selectDataContent(filterData);
  }
  
  function setIntraInterHandler(data) {
    setIntraInter(data);
    var filterData = { dateSessionStart: dateSessionStart, intraInter: data, status: status };
    setFilterDatas(filterData);
    selectDataContent(filterData);
  }

  function setStatusHandler(data) {
    setStatus(data);
    var filterData = { dateSessionStart: dateSessionStart, intraInter: intraInter, status: data };
    setFilterDatas(filterData);
    selectDataContent(filterData);
  }

  function resetFilterResetButton(filterDatas, searchTxt) {
    var showFilter = false;
    if (filterDatas.dateSessionStart !== null
      || filterDatas.intraInter !== ''
      || filterDatas.status !== '') showFilter = true;
    if (searchTxt !== '') showFilter = true;
    
    setFilterOn(showFilter);
  }

  function handleResetAll() {
    setStatus('');
    setIntraInter('');
    setDateSessionStart(null);

    setSearchText('');
    setSearchTextState('');

    var filterData = { dateSessionStart: null, intraInter: '', status: '' };
    setFilterDatas(filterData);
    setSearchTextAction('', '');
    selectDataContent(filterData);
    setFilterOn(false);
    localStorage.setItem(filterName, null);
  }


  return (
    <div className="content-filter details-block">
      <Box component="div" className="filter-box">

        <div className={filterOn ? 'resetButtonFilter' : 'resetButtonFilter hide'} onClick={handleResetAll}>
          <i className="bx bx-reset"></i><span>Réinitialiser tout</span>
        </div>

        <FormControl>
          <div className="lineContent noJustify">
            <TextFieldCustom
              fullWidth
              id="input-search"
              variant="standard"
              value={searchText}
              onChange={handleChangeSearchText}
              label=""
              className="input search"
              color={searchTextState}
              slotProps={{
                input: {
                  disableUnderline: true,
                  startAdornment: (
                    <InputAdornment position="start" >
                      <SearchIcon fontSize="medium" style={{ color: '#728094', marginLeft: '8px' }} />
                    </InputAdornment>
                  )
                }
              }}
            />
          
            <DesktopDatePickerCustom
              label="Début de session"
              value={dateSessionStart}
              onChange={setDateSessionStartHandler}
            />

            {Boolean(dataGridLoaded) && (
              <FilterCheckBox
                title="Intra / Inter"
                width="200"
                api=""
                apiParam=""
                apiParamValue=""
                loadByList="true"
                datas={[
                  {id: false, label: 'Intra'},
                  {id: true, label: 'Inter'}
                ]}
                className="input filterCheckBox"
                creator={createHandler}
                dataValueHandler={intraInter}
                setDataValueHandler={setIntraInter}
                setValueOfFilterAndSearch={setIntraInterHandler}
              />
            )}

            {Boolean(dataGridLoaded) && (
              <FilterCheckBox
                title="Tous les statuts"
                width="400"
                api=""
                apiParam=""
                apiParamValue=""
                loadByList="true"
                datas={[
                  { id: '100', label: 'A traiter' },
                  { id: '200', label: 'En cours' },
                  { id: '300', label: 'Validé' }
                ]}
                className="input filterCheckBox status"
                creator={createHandler}
                dataValueHandler={status}
                setDataValueHandler={setStatus}
                setValueOfFilterAndSearch={setStatusHandler}
              />
            )}
          </div>
        </FormControl>
      </Box>
    </div>
  );
});

export default TrainingFilter;